<mat-card appearance="outlined">

    <mat-card-header>
      <mat-card-title>
        <div>
          <span class="d-flex align-items-center">
            <span>Your Matters</span>
            <button mat-stroked-button (click)="refreshMatters()"
              class="icon-only m-l-05"><mat-icon>refresh</mat-icon></button>
          </span>
        </div>
      </mat-card-title>
    </mat-card-header>

  <mat-card-content>

    <div class="d-flex justify-content-center" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>

    @if (!loading){
      @if (pagedMatters != null) {
        <app-matters-list [pagedMatters]="pagedMatters"></app-matters-list>
      }
    }
    <a mat-button mat-stroked-button routerLink="/matters" *ngIf="pagedMatters != null && pagedMatters.totalCount > pagedMatters.pageSize" class="m-t-1">Show more...</a>
  </mat-card-content>
</mat-card>
